export default "__VITE_ASSET__CuoYm3GH__"